import { render, staticRenderFns } from "./BoolSwitch.vue?vue&type=template&id=7b150810&scoped=true&lang=html&"
import script from "./BoolSwitch.vue?vue&type=script&lang=js&"
export * from "./BoolSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BoolSwitch.vue?vue&type=style&index=0&id=7b150810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b150810",
  null
  
)

export default component.exports